<template>
  <div class="home-container">
    <div class="content-block dx-card" >
      
      <DxTabPanel 
        :items="screenTable"
        :animation-enabled="false" 
        :swipe-enabled="false"
        v-model:selected-index="screenTabSelIndex">
      </DxTabPanel>
      
      <div class="container p-2 position-relative">
        <div style=" position: absolute; right: 10px; z-index: 10;"   v-if="[].includes(screenTabSelIndex)">
          <DxButton
            :width="50"
            :height="50"
            icon="return"
            @click="returnBtn()"
          />
        </div>
        <div class="row">
          <div :class="cssClassMainImg"><canvas ref="canvas_MAIN_GROUP" ></canvas></div>
          <div :class="cssClassGraphImg"><div ref="canvas_GRAPIC_VIEW" >
           
           
          <div v-show="false">{{ signalGraphDS }} </div> 
          <div class="m-3" v-for="data in graphsListDS" :key="data.key">
            {{ data.title }} 
            <DxChart  :data-source="signalGraphDS.data" ref='graphV2'>
                <DxAnimation
                  :enabled="false"
                />
                <DxSize :height="235" />
                <DxMargin :bottom="10"/>
                <DxCommonSeriesSettings
                  type="line"
                  argument-field="timestamp"/>
                <DxSeries v-for="(data) in signalGraphDS.value.filter(s=> [data.signal1_id,data.signal2_id,data.signal3_id,data.signal4_id,data.signal5_id].includes(s.key))" :key="data.key" 
                  :value-field="'val'+data.key" 
                  :name="data.name">
                  <DxPoint :visible="true" :size="5"/>
                </DxSeries>
                <DxValueAxis
                  :show-zero="true"
                  :value-margins-enabled="false"
                  position="left"/> 
                <DxArgumentAxis
                  :visual-range="[new Date().setHours(0,0,0,0), 
                                  new Date().setHours(23, 59, 59, 999)]"
                  :tick-interval="1000*60*60"
                  :label="{customizeText:customizeHours}"/>
                <DxLegend :visible="true" vertical-alignment="bottom"  horizontal-alignment="center" />
                <DxTooltip :enabled="true" :z-index="1600" :format="{precision:'3'}"/>
              </DxChart>
            </div>
          </div>
          
          </div>

        </div>

      </div>

      <div v-if="screenTabSelIndex==2">
        <DxDataGrid
          :data-source="signalDataSource"
          :repaint-changes-only="true"
          :highlight-changes="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :show-borders="true"
        >
          <DxGrouping :context-menu-enabled="true"
            :auto-expand-all="false"/>
          <DxGroupPanel :visible="false" :allow-column-dragging="false" /> 
          <DxColumn data-field="name" caption="Name" /> <!--:customize-text="customizeTextSmm"/>-->
          <DxColumn data-field="label" caption="Label" min-width="380"/>
          <DxColumn data-field="Node.caption" :group-index="0" caption="Node" />
          <DxColumn data-field="lastValue" data-type="number" format="#0.####" >
            <DxFormat
              type="decimal"
              />
          </DxColumn> 
          <DxColumn data-field="units" :width="70" />
          <DxColumn data-field="lastReceived" data-type="datetime" format="yyyy-MM-dd, hh:mm:ss a" />
        </DxDataGrid>
      </div>
      
      <div v-if="screenTabSelIndex==3">
        <div v-if="kpiNumberBoxes.length" class="kpi-container" style="margin-top: 0.6rem;">
          <div v-for="sig in kpiNumberBoxes" :key="sig.signalId" class="kpi">
            <p class="kpi__title ">{{sig.label}} </p>
            <p class="kpi__value" >{{sig.lastValue}} <small>{{sig.units}}</small></p>
            <p class="kpi__description slds-text-color_weak">{{sig.Node?.caption}}</p>
          </div>
        </div>

        <div v-if="kpiGaugeBoxes.length" class="kpi-container">
          <DxBarGauge v-for="sig in kpiGaugeBoxes" :key="sig.signalId"
            style="border: 1px solid #ebedef; border-radius: 10px; margin-right: .6rem;"
            :start-value="sig.kpiConfig.startValue||0"
            :end-value="sig.kpiConfig.endValue||100"
            :values="[sig.lastValue]"
            :size="{height: 270, width: 270}"
            :title="{ font: {size: 20, weight: 400}, margin:0, text: sig.label, subtitle: sig.Node?.caption }" >
            <DxTooltip :enabled="true" />
          </DxBarGauge>
        </div>
      </div>

      <div v-if="screenTabSelIndex==4">
        <DxDataGrid
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          column-resizing-mode="next-column"
          :data-source="logDataSource">
          <DxColumn data-field="level" width="80"></DxColumn>
          <DxColumn data-field="message"></DxColumn>
          <DxColumn data-field="time" width="180" data-type="datetime" format="yyyy-MM-dd, hh:mm:ss a" :fixed="true" :sort-index="0" sort-order="desc"></DxColumn>
          <DxColumn data-field="source"></DxColumn>
          <DxColumnChooser :enabled="true" mode="select" />
          <DxSelection mode="single"/>
          <DxPaging :page-size="10"/>
          <DxPager
            :visible="true"
            :allowed-page-sizes="[10, 20, 50]"
            display-mode="full"
            :show-page-size-selector="true"
            :show-info="true"
            :show-navigation-buttons="true"
          />
          <DxHeaderFilter
              :visible="true"
            />
        </DxDataGrid>
      </div>


      <div v-if="screenTabSelIndex==5">
        <emsView/>
      </div>
    </div>

    <DxPopup
      content-template="popup-mqtt-method"
      :title="mqttCommandPopupTitle"
      :show-close-button="true"
      v-model:visible="isSendCommandVisible"
      :height="370"
      :width="370" 
      :hide-on-outside-click="true">
      <template #popup-mqtt-method>
        <DxScrollView width="100%" height="100%" >
          <div>
            <div>
              <form @submit.prevent="mqttPublish">
              </form>
            </div>
          </div>
        </DxScrollView>
      </template>            
    </DxPopup>

    <DxPopup
      :title="GraphPopupNodeId?.name"
      v-model:visible="isGraphPopupOpen"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :width="1400"
      :height="710">
  
      <div class="row" >
        <div class="col-6" style="margin-top:12px">

          <DxDataGrid
            class=""
            :data-source="(enfyoSignals.filter(s=>s.Node?.id==GraphPopupNodeId?.id))"
            :repaint-changes-only="true"
            :highlight-changes="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :show-borders="true"
          >
            <DxPaging :page-size="14"/>
            <DxColumn data-field="label" caption="Label" :min-width="380"/>
            <DxColumn data-field="lastValue" data-type="number" format="#0.####" >
              <DxFormat
                type="decimal"
                />
            </DxColumn> 
            <DxColumn data-field="units" :width="60" />
            <DxColumn data-field="lastReceived" data-type="datetime" format="hh:mm:ss a" :min-width="150" />
          </DxDataGrid>
         
        </div>
        <div class="col-6"> 
         <div v-for="item in signalGraphDS" :key="item.key">
            <div v-for="data in item.filter((s)=>s.node==GraphPopupNodeId?.id).slice(0,3)" :key="data.key" > 
              <div> {{ data?.name }} {{ data?.units?'['+data.units+']':'' }} 
                <div style="float:right" v-if="data.GraphType=='area'"> Mean: {{ data.stats?.integral }} {{ data?.units }} </div>
              </div>
              
              <DxChart  v-if="(data.node==GraphPopupNodeId?.id &&  !data.units.includes('W'))" :data-source="signalGraphDS.data">
                <DxAnimation
                  :enabled="false"
                />
                <DxSize :height="185" />
                <DxMargin :bottom="10"/>
                <DxCommonSeriesSettings
                  :type="data.GraphType"
                  argument-field="timestamp"/>
                <DxSeries :value-field="'val'+data.key">
                  <DxPoint :visible="true" :size="5"/>
                </DxSeries>
                <DxValueAxis
                  :show-zero="true"
                  :value-margins-enabled="false"
                  position="left"/> 
                <DxArgumentAxis
                  :visual-range="[new Date().setHours(0,0,0,0), 
                                  new Date().setHours(23, 59, 59, 999)]"
                  :tick-interval="1000*60*60"
                  :label="{customizeText:customizeHours}"/>
                <DxLegend :visible="false" />
                <DxTooltip :enabled="true" :z-index="1600" :format="{precision:'3'}"/>
              </DxChart>

              <DxChart  v-if="(data.node==GraphPopupNodeId?.id &&  data.units.includes('W'))" :data-source="signalGraphDS.data">
                <DxAnimation
                  :enabled="false"
                />
                <DxSize :height="185" />
                <DxMargin :bottom="10"/>
                <DxCommonSeriesSettings
                  :type="data.GraphType"
                  argument-field="timestamp"/>
                <DxSeries :value-field="'val'+data.key"
                  :name="data.name">
                  <DxPoint :visible="true" :size="5"/>
                </DxSeries>
                <!--<DxSeries value-field="PV"
                  name="PV">
                  <DxPoint :visible="true" :size="5"/>
                </DxSeries>-->
                <DxValueAxis
                  :show-zero="true"
                  :value-margins-enabled="false"
                  position="left"/> 
                <DxArgumentAxis
                  :visual-range="[new Date().setHours(0,0,0,0), 
                                  new Date().setHours(23, 59, 59, 999)]"
                  :tick-interval="1000*60*60*2"
                  :label="{customizeText:customizeHours}"/>
                <DxLegend :visible="true" vertical-alignment="top"  horizontal-alignment="center"/>
                <DxTooltip :enabled="true" :z-index="1600" :format="{precision:'3'}"/>
              </DxChart>
              
            </div>
          </div>
         
          <h5 style=" text-align: center; ">{{enfyoSignals.filter(s=> s.Node?.id==GraphPopupNodeId?.id).length==0?'No data to display': 'Time [h:m]'}}</h5>
          
        </div>
      </div>  
    </DxPopup> 

  <DxPopup
      title="Bus"
      v-model:visible="isBusPopupOpen"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :max-width="1000"
      :max-height="800">
      <DxScrollView width="100%" height="100%" >
        
      </DxScrollView>
    </DxPopup>

  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore} from 'vuex';

import emsView from '../components/realtime-monitor-ems.vue';
import DxButton from 'devextreme-vue/button';
import * as PIXI from 'pixi.js'
import 
  DxDataGrid, {
    DxColumn,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxPager,
    DxPaging,
    DxSelection,
    DxFormat,
    DxHeaderFilter,
} from 'devextreme-vue/data-grid';

import {
  PowePVList,
} from '../services/PredictionsPVDS.js';


import { DxBarGauge, DxTooltip } from 'devextreme-vue/bar-gauge';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxTabPanel from "devextreme-vue/tab-panel";
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';

import { 
  attachGraphics, 
  buildGraphsMap, 
  registerSignals, 
  registerGraphSignals,
  registerAnimationSignals,
  updateKpiSigVals, 
  updateAnimationsSigVals,
} from '../utils/realtime-canvas';
import RawDataService from '../services/RawDataServiceTemplate';
import MqttEnfyoClient from '../utils/MqttEnfyoClient';
import appInfo from '../app-info.js';
import {
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxLegend,
  DxValueAxis,
  DxSeries,
  DxMargin,
  DxSize,
  DxPoint,
  DxAnimation,
} from 'devextreme-vue/chart';

export default {
  name: 'RealtimeMonitor',
  components: {
    DxTabPanel,
    DxPopup,
    DxScrollView,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxHeaderFilter,
    DxPager,
    DxPaging,
    DxSelection,
    DxBarGauge, 
    DxTooltip, 
    DxChart,
    DxCommonSeriesSettings,
    DxSize,
    DxArgumentAxis,
    DxSeries,
    DxPoint,
    DxLegend,
    DxAnimation,
    DxMargin,
    DxValueAxis,
    DxButton,
    DxFormat,
    emsView
  },
  data(){
  
  },
  setup() {
    //TODO: controls for conn status and button for dashboard explorer

    const store = useStore();

    const isGraphPopupOpen = ref(false);
    const isBusPopupOpen = ref(false);
    const GraphPopupNodeId = ref({id:'',name:'',signal1_id:'',signal2_id:'',signal3_id:''});
    const signalGraphDS = reactive({value: [], data: []});
    const signalGraphViewDS = reactive({value: [], data: []});



// *********************** Data Management declarations ************************
    const logSrc = [{ level: 'info', time: new Date(), source: "rt_monitor", message: "Web realtime-monitor started" }];
    const logDataSource = new DataSource({ store: new ArrayStore({ key: 'time', data:logSrc }), paginate: false });
    const mastersDataService = new RawDataService(`masters`);
    const staticTablesDataService = new RawDataService(`statics/tables`);
    const influxDataService = new RawDataService(`influx`); 
    const signalSet = new Set(); // list of processed signal id
    const enfyoSignals = ref([]); // signal properties array
    const kpiNumberBoxes = computed( () => enfyoSignals.value.filter(s => !!s.isKpi && s.kpiType=="number") );
    const kpiGaugeBoxes = computed( () => enfyoSignals.value.filter(s => !!s.isKpi && s.kpiType=="gauge") );
    const signalDataSource = ref([]); // dataSource for signal table
    let signalStore = null; // dataStore for signal data
    const graphsListDS = ref([])
    // *********************** Graphic Objects declarations and methods ************
    const screenTabSelIndex = ref(0);
    const screenTable = ref([
      { ctrId: 'MAIN_GROUP', title:'General View', disabled: false },
      { ctrId: 'GRAPHIC_VIEW', title:'Graphic View', disabled: false },
      { title: "Signal Table", disabled: false },
      { title: "KPI View", disabled: false},
      { title: "Realtime Log", disabled: false },
      { ctrId: 'EMS_VIEW', title:'EMS View', disabled: false },
    ]);
    /** @type {Map<string, EnfyoGraphicNode[]>} */
    let screenNodesMap = null;
    /** @type {{ MAIN_GROUP:PIXI.Application, DER_DC:PIXI.Application, DER_AC:PIXI.Application, LOADS:PIXI.Application }} */
    const pixiApps = {}; // object containing PIXI apps (graphic screens)
    const renderer = {}; // object containing PIXI apps (graphic screens)
    const canvas_MAIN_GROUP = ref(null);
    const canvas_GRAPHIC_VIEW = ref(null);

    const canvasHeights = ref({ 
      MAIN_GROUP: 0,
      DER_AC: 0 ,
      DER_DC: 0,
      LOADS: 0,
      BUS: 0
    });

    const cssClassMainImg = computed(() => { return (screenTabSelIndex.value==0)?'col-12': 'col-12 d-none'; });
    const cssClassGraphImg = computed(() => { return (screenTabSelIndex.value==1)?'col-12': 'col-12 d-none'; });
    const canvasObjSelector = (screenName) => {
      if(screenName=='MAIN_GROUP') return canvas_MAIN_GROUP;
      if(screenName=='GRAPHIC_VIEW') return canvas_GRAPHIC_VIEW;
    }
    const canvasSelector = (screenName) => {
      return canvasObjSelector(screenName).value;
    }

    const returnBtn = () =>{
      screenTabSelIndex.value=0;
    } 

    // ************************* Mqtt declarations *********************************
    /** @type {MqttEnfyoClient} */
    let mqttClient = null; 
    const mqttProtocol = appInfo.serverProtocol=='https:'? 'wss':'ws'; 
    const mqttUrl = `${mqttProtocol}://${appInfo.serverHostname}:${appInfo.serverPort}/mqtt`;
    const mqttOptions = {
      keepalive: 30,
      clientId: 'enfyoWebApp_' + Math.random().toString(16).substring(2, 10),
      protocolId: 'MQTT',
      protocolVersion: 4,
      clean: true,
      reconnect: true,
      reconnectInterval: 20*1000,
      reconnectPeriod: 30*1000, 
      queueQoSZero: false,
      username: store.state.user.username,
      password: store.state.user.sessionId,
    }
    const topicsArr = [
      { topic: 'json/assets/+/logs', qos: 0 },
      { topic: 'json/signalState', qos: 0 },
      { topic: `json/assets/+/commandRes/${store.state.user.username}`, qos: 0 },
    ];
    const mqttLogHandler = (evt) => { logAppend(evt.description, evt.level) };
    const formatSigValue = (signalValue) => {
      if(signalValue==null) return '-'
      if(typeof(signalValue)=='string') return Math.round(parseFloat(signalValue)*1000)/1000;// signalValue.substring(0,10);
      if(typeof(signalValue)=='number'){
        return Math.round(signalValue*1000)/1000;
      }
      if(typeof(signalValue)=='boolean') return signalValue? 1:0;
      return '#'
    }
    const receiveMsg = (topic, message) => {
      try{
        const topicArr = topic.split('/');
        const messageObj = JSON.parse(message.toString());
        if(topicArr.length==2 && topicArr[0]=='json' && topicArr[1]=='signalState'){
          updateSignalValues(messageObj);
        }
        else if(topicArr.length==4 && topicArr[0]=='json' && topicArr[1]=='assets' && topicArr[3]=='logs'){
          const assetId=topicArr[2];

          logAppend(messageObj.message, messageObj.level||'http', assetId, messageObj.timestamp);
        }
        else if(topicArr[0]=='json' && topicArr[1]=='assets' && topicArr[3]=='commandRes'){
          console.log('command response detected', messageObj);
        }else{ logAppend('topic MQTT no reconocido: '+topic, 'warn'); }
        //TODO: implement commands
      }
      catch(err){ logAppend('MQTT message error: '+err.message, 'error'); }
    };

    // ******************** signal & logs control updaters *********************
    const updateSignalValues = (mqttSignalData) => {

      //const currentDate = new Date();
      for (const sig of mqttSignalData){ //update datastorage for tables and KPI controls
        sig.GraphScale=1;

        
        //if(signalGraphDS.value.filter(p => p.key==sig.signalId).length>0 && !["*FAULT*","WARNING","Run"].includes(sig.currentValue)){
          // Set Units
          if(sig.units=='W' && Math.abs(sig.currentValue)>= 1000 && Math.abs(sig.currentValue)< 1000000){
            sig.units='kW'
            sig.GraphScale=1/1000
          }else if(sig.units=='W' && Math.abs(sig.currentValue)>= 1000000 && Math.abs(sig.currentValue)< 1000000000){
            sig.units='MW'
            sig.GraphScale=1/1000000
          }else if(sig.units=='W' && Math.abs(sig.currentValue)>= 1000000000){
            sig.units='TW'
            sig.GraphScale=1/1000000000
          }else if(sig.units=='kW' && Math.abs(sig.currentValue)>= 1000 && Math.abs(sig.currentValue)< 1000000){
            sig.units='MW'
            sig.GraphScale=1/1000
          }else if(sig.units=='kW' && Math.abs(sig.currentValue)>= 1000000 && Math.abs(sig.currentValue)< 1000000000){
            sig.units='TW'
            sig.GraphScale=1/1000000
          }else if(sig.units=='Wh' && Math.abs(sig.currentValue)>= 1000 && Math.abs(sig.currentValue)< 1000000){
            sig.units='kWh'
            sig.GraphScale=1/1000
          }else if(sig.units=='Wh' && Math.abs(sig.currentValue)>= 1000000 && Math.abs(sig.currentValue)< 1000000000){
            sig.units='MWh'
            sig.GraphScale=1/1000000
          }else if(sig.units=='Wh' && Math.abs(sig.currentValue)>= 1000000000){
            sig.units='TWh'
            sig.GraphScale=1/1000000000
          }else if(sig.units=='kWh' && Math.abs(sig.currentValue)>= 1000 && Math.abs(sig.currentValue)< 1000000){
            sig.units='MWh'
            sig.GraphScale=1/1000
          }else if(sig.units=='kWh' && Math.abs(sig.currentValue)>= 1000000 && Math.abs(sig.currentValue)< 1000000000){
            sig.units='TWh'
            sig.GraphScale=1/1000000
          }else if(sig.units=='mA' && Math.abs(sig.currentValue)>= 1000 && Math.abs(sig.currentValue)< 1000000 ){
            sig.units='A'
            sig.GraphScale=1/1000
          }else if(sig.units=='V' && Math.abs(sig.currentValue)>= 1000 && Math.abs(sig.currentValue)< 1000000){
            sig.units='kV'
            sig.GraphScale=1/1000
          }else if(sig.units=='V' && Math.abs(sig.currentValue)>= 1000000 && Math.abs(sig.currentValue)< 1000000000){
            sig.units='MV'
            sig.GraphScale=1/1000000
          }else if(sig.units=='V' && Math.abs(sig.currentValue)>= 1000000000){
            sig.units='TV'
            sig.GraphScale=1/1000000000
          }
          
        //}
        let value = formatSigValue(parseFloat(sig.currentValue*sig.GraphScale))
        if(isNaN(value)){
          value=sig.currentValue
        }
          
        if (signalSet.has(sig.signalId)){
          signalStore.push([{ 
            type: 'update', 
            key: sig.signalId, 
            data: { lastValue: value, lastReceived: sig.updatedAt, units: sig.units }
          }])
        }
        
      }
        if(screenNodesMap.size==0) return ;
        
        updateKpiSigVals(screenNodesMap, mqttSignalData); //update values in canvas
        updateGraphSigVals(mqttSignalData);//update values in popup
        updateAnimationsSigVals(screenNodesMap, mqttSignalData); //update values in canvas
      
    }
    const logAppend = (message, level, source="rt_monitor",timestamp) => {
      let time = timestamp? new Date(timestamp).toISOString(): new Date().toISOString()
      logDataSource.store().insert({level, time: time, source, message});
      logDataSource.reload();
    };
   

    onMounted(async () => {
      try{
        //** initializes mqtt */
        if(mqttClient) await mqttClient.stop()

        mqttClient = new MqttEnfyoClient('webapp', mqttUrl, mqttOptions, topicsArr, receiveMsg);
        mqttClient.onConnectionLog(mqttLogHandler);
        console.log('mqtt start')
        await mqttClient.start();
        logAppend('MQTT data streaming online', 'info');

        /** initializes datasources */
        const signalsData = await mastersDataService.getByKey('signals');
        const assetsData = await mastersDataService.getByKey('assets');
        const nodeFamilies = await staticTablesDataService.getByKey('graphNodeFamilies');
        const graphNodes = await mastersDataService.getByKey('enfyoGraphNodes');
        
        graphNodes.map(sysNode => { //attach node family to node
          sysNode.NodeType = nodeFamilies.find?.(nf => nf.id==sysNode.node);
          return sysNode;
        });
        signalsData.map(sig => { //attach asset to signal
          sig.Asset = assetsData.find?.( as => as.name==sig.assetName);
          sig.Node = graphNodes.find?.( nd => nd.asset_id==sig.Asset?.id);
          sig.lastValue = sig.staticValue||null;
          sig.lastReceived = null;
          signalSet.add(sig.signalId); //save a list of signals for fast querying
          //if(sig.label=='' || !sig.label) sig.label=sig.name
          return sig
        })

        enfyoSignals.value = signalsData.filter(s=>!!s.isKpi);
        signalStore = new ArrayStore({ data: signalsData.filter(s=>!!s.isKpi && !!s.Node && !!s.Node.enabled) , key: 'signalId' });
        signalDataSource.value = signalStore;
       
        // initializes map of graphs and graphic nodes 
        screenNodesMap = buildGraphsMap(graphNodes);
        // create graphic elements for nodes 
        const cvProps = await attachGraphics(screenNodesMap);
        // create and draw canvas graphics
        
        for(const [screnName, screnNodes] of screenNodesMap){ //create screens and graphics
          let screen = screenTable.value.find(sc => sc.ctrId==screnName)
          
          if (screen){
            screen.disabled = false;
            pixiApps[screnName]?.destroy?.();
            pixiApps[screnName] = new PIXI.Application({
              antialias: false, 
              width: 3280,
              height: cvProps[screnName].canvasHeight,
              backgroundColor: 0xfefefe,
              backgroundAlpha: 1,
              view: canvasSelector(screnName),
            });
            canvasHeights.value[screnName]=cvProps[screnName].canvasHeight;

            renderer[screnName] = PIXI.autoDetectRenderer(300, 300);
            pixiApps[screnName].stage.sortableChildren = true;
            
            //pixiApps[screnName].stage.scale.set(0.8,0.8);
            pixiApps[screnName].view.style.width = '100%';

            for(const node of screnNodes){ // draw graphic elements
              if(!node.graphics) continue;
              
              for(const [graphN, graphEl] of node.graphics){
                // buttons funcionality
                if(graphN=="mainGraph" || graphN=="contactor_CGM" || graphN=="contactor_CBT"){
                  graphEl.on('click',()=>{
                    GraphPopupNodeId.value={id:node.id,name:node.caption,signal1_id:node.signal1_id,signal2_id:node.signal2_id,signal3_id:node.signal3_id};
                    isGraphPopupOpen.value =  true;
                  })
                }
                
                pixiApps[screnName].stage.addChild(graphEl);
              }
            }
            pixiApps[screnName].render();
          }
        }
        // register signals kpis (battery included)      
        registerSignals(screenNodesMap, signalsData)
      
        
        // register signal animatio
        registerAnimationSignals(screenNodesMap, signalsData)

        // register signals popups graph
        let Signals;
        const graphDataService = new RawDataService(`masters/graphicView`);
        const graphsList = await graphDataService.getAll() 
        
        let grapViewSignals=[]
        for(var graph of graphsList){
          if(graph.signal1_id){
            let sig = signalsData.find(s=> s.signalId == graph.signal1_id)
            grapViewSignals.push(sig)
            graph.signal1= sig
          } 
          if(graph.signal2_id){
            let sig = signalsData.find(s=> s.signalId == graph.signal2_id)
            grapViewSignals.push(sig)
            graph.signal2= sig
          } 
          if(graph.signal3_id){
            let sig = signalsData.find(s=> s.signalId == graph.signal3_id)
            grapViewSignals.push(sig)
            graph.signal3= sig
          } 
          if(graph.signal4_id){
            let sig = signalsData.find(s=> s.signalId == graph.signal4_id)
            grapViewSignals.push(sig)
            graph.signal4= sig
          } 
          if(graph.signal5_id){
            let sig = signalsData.find(s=> s.signalId == graph.signal5_id)
            grapViewSignals.push(sig)
            graph.signal5= sig
          } 
        }
        
        graphsListDS.value=graphsList.sort((a,b)=> a.order - b.order)
  
        const res = await registerGraphSignals(screenNodesMap, signalsData, grapViewSignals)
        Signals=res;
        signalGraphDS.value = Signals.value;
        signalGraphDS.data = Signals.data;

        for(var i = 0; i < PowePVList.length; i++){
        let PV = PowePVList[i];
          signalGraphDS.data.push({
            timestamp: PV.time.getTime()-1664578800000 + new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getUTCDay()).getTime()+1000*60*60*50,//PU.time.getHours()+ ':' + PU.time.getMinutes(), //"T.Alta_09_14",
            PV:parseFloat(PV.value)/1000,
          })
        }
        
       
        const initTime=new Date().getTime()-1000*60*60*24;
        const endTime=new Date().getTime()-1;
        influxDataService.getByKey('/mqttLogs/?dateStart='+initTime+'&dateEnd='+endTime+'&limit=100' ).then((dataInflux) =>{ for(const data of dataInflux){
            logDataSource.store().insert({level: data.service, time: data.time, source:data.deviceUid, message: data.message});
            }
          }).catch(()=>console.log('error in influx loading')); 
      
        
      }

      catch(err){
        notify('error mounting: '+err.message, "error", 3000);
      }
    
    });
    

    
    const graphV1 = ref()
    const graphV2 = ref()
    const updateGraphSigVals =  ( mqttSignalData)=>{  // TODO: Move to realtime-canvas.js
  
      for(const item of mqttSignalData){  
        if(signalGraphDS.value.filter(p => p.key==item.signalId).length>0){
          let sigData=signalGraphDS.data;
          const sigValue=signalGraphDS.value.find(p => p.key==item.signalId);
        
          sigData.push({timestamp: item.updatedAt, ['val'+item.signalId] : item.currentValue, signal: item.signalId})

          let arr = signalGraphDS.data.filter((p)=>p.signal==item.signalId);
          arr = arr.map(e => ({
              ...e,
              timestamp: Math.floor(e.timestamp/(10*60*1000))*10*60*1000
          }));
          
          
          let result = Object.values(arr.reduce((acc, e) => {
              if (!acc[e.timestamp]) {
                  acc[e.timestamp] = {...e, count: 1};
              } else {
                acc[e.timestamp]['val'+e.signal] = parseFloat(e['val'+e.signal]); // Last value
             
              }
              return acc;
          }, {})).map(e => ({timestamp:e.timestamp, ['val'+e.signal]: e['val'+e.signal], signal: e.signal}));// Last value
         
          signalGraphDS.data = signalGraphDS.data.filter(e => e.signal !=item.signalId)
          for(var sig of result){
            signalGraphDS.data.push(sig)
          }

          sigValue.units=item?.units || '' ;
          sigValue.GraphScale=item?.GraphScale || 1;
          // Updating stats
          const arrayData = Array.from(sigData.filter(p=>p.signal==item.signalId), x => x['val'+x.signal]*sigValue.GraphScale);
          for(const stat of Object.keys(sigValue.stats).filter(fn => fn.includes('FN'))){
            sigValue.stats[stat.slice(0,-2)] = sigValue['stats'][stat](arrayData);
          }
        }
       
      }
    }


    onBeforeUnmount(() => {
      mqttClient.offConnectionLog(mqttLogHandler);
      console.log('mqtt stop')
      mqttClient.stop();
    });


    /** mqtt commands implementation */
    const isSendCommandVisible = ref(false);
    const mqttCommandPopupTitle = ref('Send Command (method)');
    const mqttPublish = (cmdName, payload) => {
      const topic = 'json/assets/red_ac/commands/'+cmdName;
      const qos = 0;
      if(!mqttClient.client) {console.log('client offline'); return ;}
       mqttClient.client.publish(topic, JSON.stringify(payload), qos, err => {
        if (err) { notify('Error in msg publish: ' + err.message, "error", 3000); }
      })
      notify('Message Sent to the device', "success", 3000);
    };
    const changeState = (e) => {
      if(e.addedItems?.[0]){
        mqttPublish('workingModeChange', e.addedItems[0]);
      }

    }

    const customizeHours = ( value ) => {
      var date = new Date(value.value)
      return formatDate(date);
    };
    function formatDate(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes ;
      return strTime;
    }
    

    return {
      customizeHours,
      signalGraphDS,
      isGraphPopupOpen,
      isBusPopupOpen,
      screenTabSelIndex,
      screenTable,
      cssClassMainImg,
      cssClassGraphImg,
      canvas_MAIN_GROUP,
      canvas_GRAPHIC_VIEW,
      canvasHeights,
      graphV1,
      graphV2,
      mqttPublish,
      isSendCommandVisible,
      mqttCommandPopupTitle,
      signalGraphViewDS,
      changeState,

      signalDataSource,
      enfyoSignals,
      kpiNumberBoxes,
      kpiGaugeBoxes,
      logDataSource,
      GraphPopupNodeId,
      graphsListDS,

      returnBtn,
    }
  },
  

}

</script>

<style lang="scss">
@import url('../themes/base.scss');

.home-container {
  max-width: 1450px;
  margin: 0 auto;
}

.kpi-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.kpi {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 160px;
  width: 270px;
  margin-right: .6rem;
  margin-bottom: .6rem;
  padding: 1rem 1.5rem;
  border: 1px solid #ebedef;
  border-radius: 10px;
  text-align: center;
}

.kpi__value {
  margin-top: 0.1rem;
  margin-bottom: .25rem;
  font-size: 3rem;
  line-height: 1;
  
  small {
    font-size: .5em;
  }
  
  svg {
    margin-top: -.75rem;
    border: 1px dashed pink;
  }
}

.kpi__description {
  font-size: 1rem;
  line-height: 1.2;
}
.kpi__title {
  font-size: 1.3rem;
}


</style>